import { useEffect } from "react";

export function useFlashMessage({ message, type = "success", duration = 4000, onClose }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return { message, type, duration, onClose };
}

